<template>
  <div class="tpage">
    <div class="topbar">
      <el-button type="text" icon="el-icon-arrow-left" @click="$router.push('/thome')">返回</el-button>
      <span class="title">消息通知</span>
      <span class="topbar-pad"></span>
    </div>

    <div class="body">
      <!-- ============ 编辑区 ============ -->
      <el-card class="form-card" shadow="never">
        <p class="sec-title">
          {{ editId ? '修改通知' : '新建通知' }}
          <el-button v-if="editId" type="text" size="mini" @click="resetForm">取消修改</el-button>
        </p>

        <el-form label-position="top" @submit.native.prevent>
          <el-form-item label="标签（标题）">
            <el-input v-model.trim="form.tag" maxlength="50" placeholder="如：月考安排 / 课表公布"></el-input>
            <div class="chips" v-if="tags.length">
              <span class="chip" v-for="t in tags" :key="t" @click="form.tag = t">{{ t }}</span>
            </div>
          </el-form-item>

          <el-form-item label="通知内容">
            <el-input v-model="form.content" type="textarea" :rows="6" maxlength="1000" show-word-limit
                      placeholder="输入或粘贴通知正文，可从下方历史通知一键带入"></el-input>
          </el-form-item>

          <p class="fill-tip" v-if="copiedTag">
            <i class="el-icon-document-copy"></i> 已带入历史通知「{{ copiedTag }}」，修改后保存会「新增一条」，原通知不受影响
            <el-button type="text" size="mini" @click="resetForm">取消带入</el-button>
          </p>

          <div class="form-ops">
            <el-button type="primary" :loading="saving" @click="save">{{ editId ? '保存修改' : '保存通知' }}</el-button>
            <el-button @click="resetForm">清空</el-button>
          </div>
        </el-form>
      </el-card>

      <!-- ============ 筛选区 ============ -->
      <div class="search-bar">
        <el-input v-model.trim="keyword" size="small" clearable placeholder="搜标签 / 通知内容"
                  @keyup.enter.native="search" @clear="search"></el-input>
        <el-button size="small" type="primary" :loading="loading" @click="search">搜索</el-button>
      </div>

      <div class="filter-bar">
        <el-radio-group v-model="order" size="mini" @change="search">
          <el-radio-button label="latest">最新</el-radio-button>
          <el-radio-button label="hot">最常用</el-radio-button>
        </el-radio-group>
        <el-select v-model="filterTag" size="mini" clearable placeholder="全部标签" class="tag-filter"
                   @change="search">
          <el-option v-for="t in tags" :key="t" :label="t" :value="t"></el-option>
        </el-select>
      </div>

      <!-- ============ 列表 ============ -->
      <el-card class="n-card" shadow="never" v-for="item in list" :key="item.id">
        <div class="n-head">
          <span class="n-tag">{{ item.tag }}</span>
          <span class="n-meta">
            {{ (item.create_time || '').slice(0, 10) }}
            <em v-if="item.use_count > 0" class="used">用过 {{ item.use_count }} 次</em>
          </span>
        </div>
        <div class="n-content">{{ item.content }}</div>
        <div class="n-foot">
          <el-button type="text" size="mini" icon="el-icon-plus" class="use-btn" @click="useNotice(item)">复制使用</el-button>
          <el-button type="text" size="mini" icon="el-icon-document-copy" @click="copyText(withTime(item.content))">复制文本</el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="editNotice(item)">编辑</el-button>
          <el-button type="text" size="mini" icon="el-icon-delete" class="del-btn" @click="delNotice(item)">删除</el-button>
        </div>
      </el-card>

      <p class="empty" v-if="loaded && list.length === 0">还没有通知记录</p>

      <div class="more" v-if="hasMore">
        <el-button size="small" :loading="loading" @click="loadMore">加载更多</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  noticeList, noticeTags, noticeAdd, noticeUpdate, noticeDelete, noticeUse, getTeacherLogin
} from '@/api/teacher.js'

const PAGE_SIZE = 20

export default {
  name: 'TeacherNotice',
  data() {
    return {
      tags: [],
      list: [],
      page: 1,
      hasMore: true,
      loading: false,
      loaded: false,
      saving: false,
      keyword: '',
      order: 'latest',
      filterTag: '',
      editId: null,
      copiedTag: '',
      form: { tag: '', content: '' }
    }
  },
  mounted() {
    if (!getTeacherLogin().token) {
      this.$router.replace('/tlogin')
      return
    }
    this.loadTags()
    this.load()
  },
  methods: {
    /** 标签去重列表（用于快捷选择与筛选） */
    loadTags() {
      noticeTags()
        .then((res) => {
          this.tags = Array.isArray(res) ? res.filter(Boolean) : []
        })
        .catch(() => {
          this.tags = []
        })
    },
    load() {
      this.loading = true
      noticeList({
        page: this.page,
        keyword: this.keyword,
        tag: this.filterTag,
        order: this.order
      })
        .then((data) => {
          this.loading = false
          this.loaded = true
          const rows = Array.isArray(data) ? data : (data && data.data ? data.data : [])
          this.list = this.page === 1 ? rows : this.list.concat(rows)
          this.hasMore = rows.length >= PAGE_SIZE
        })
        .catch(() => {
          this.loading = false
          this.loaded = true
          this.$message.error('加载失败，请稍后重试')
        })
    },
    search() {
      this.page = 1
      this.loaded = false
      this.list = []
      this.load()
    },
    loadMore() {
      this.page += 1
      this.load()
    },
    /** 保存：编辑模式走 update，否则新增 */
    save() {
      if (!this.form.tag) {
        this.$message.warning('请填写通知标签')
        return
      }
      if (!this.form.content.trim()) {
        this.$message.warning('请填写通知内容')
        return
      }
      this.saving = true
      const payload = { tag: this.form.tag, content: this.form.content }
      const task = this.editId
        ? noticeUpdate(Object.assign({ id: this.editId }, payload))
        : noticeAdd(payload)

      task
        .then((res) => {
          this.saving = false
          if (!res || res.status !== 'success') {
            this.$message.error((res && res.message) || '保存失败')
            return
          }
          this.$message.success(this.editId ? '修改成功' : '保存成功')
          this.resetForm()
          this.loadTags()
          this.search()
        })
        .catch(() => {
          this.saving = false
          this.$message.error('保存失败，请检查网络后重试')
        })
    },
    /** 复制使用：把历史通知带进编辑区，并累计复用次数（用于「最常用」排序） */
    useNotice(item) {
      this.editId = null
      this.copiedTag = item.tag
      this.form.tag = item.tag
      this.form.content = item.content
      this.toTop()
      // 计数失败不影响使用
      noticeUse(item.id).catch(() => {
        // 网络异常时忽略计数
      })
    },
    editNotice(item) {
      this.editId = item.id
      this.copiedTag = ''
      this.form.tag = item.tag
      this.form.content = item.content
      this.toTop()
    },
    delNotice(item) {
      this.$confirm('确定删除这条通知吗？删除后不可恢复。', '删除确认', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => noticeDelete(item.id))
        .then((res) => {
          if (res === 'success') {
            this.$message.success('删除成功')
            if (this.list.length === 1 && this.page > 1) {
              this.page -= 1
            }
            this.loadTags()
            this.load()
          } else {
            this.$message.error('删除失败，请稍后重试')
          }
        })
        .catch(() => {
          // 用户取消
        })
    },
    resetForm() {
      this.editId = null
      this.copiedTag = ''
      this.form.tag = ''
      this.form.content = ''
    },
    toTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    /** ---------- 复制到剪贴板 ---------- */
    /** 正文末尾补一行当前时间（精确到秒），方便粘贴到群里让别人知道发送时间 */
    withTime(text) {
      const d = new Date()
      const p = (n) => (n < 10 ? '0' + n : '' + n)
      const stamp = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) +
        ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds())
      return (text || '') + '\n' + stamp
    },
    copyText(text) {
      const done = () => this.$message.success('内容已复制')
      const fail = () => this.$message.error('复制失败，请手动选择文字复制')
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(done).catch(() => this.fallbackCopy(text, done, fail))
      } else {
        this.fallbackCopy(text, done, fail)
      }
    },
    /** http 环境下 clipboard API 不可用，退回 execCommand */
    fallbackCopy(text, done, fail) {
      try {
        const ta = document.createElement('textarea')
        ta.value = text
        ta.style.position = 'fixed'
        ta.style.left = '-9999px'
        ta.style.opacity = '0'
        document.body.appendChild(ta)
        ta.focus()
        ta.select()
        const ok = document.execCommand('copy')
        document.body.removeChild(ta)
        if (ok) {
          done()
        } else {
          fail()
        }
      } catch (e) {
        fail()
      }
    }
  }
}
</script>

<style scoped>
.tpage {
  min-height: 100vh;
  background: #f5f7fb;
}
.topbar {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #3b6ef0;
  color: #fff;

  ::v-deep .el-button {
    color: #fff;
    padding: 0;
    font-size: 14px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
  }
  .topbar-pad {
    width: 56px;
  }
}
.body {
  padding: 12px;
}
.form-card {
  border-radius: 10px;
  border: none;
  margin-bottom: 12px;

  ::v-deep .el-card__body {
    padding: 12px 14px;
  }
}
.sec-title {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 600;
  color: #2c3550;

  ::v-deep .el-button {
    float: right;
    padding: 0;
    font-size: 12px;
  }
}
.chips {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.chip {
  padding: 2px 10px;
  font-size: 12px;
  color: #3b6ef0;
  background: #eef3ff;
  border-radius: 10px;
  cursor: pointer;
}
.fill-tip {
  margin: 0 0 10px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #8a6d00;
  background: #fff8e6;
  border-radius: 6px;

  ::v-deep .el-button {
    padding: 0;
    margin-left: 4px;
    font-size: 12px;
  }
}
.form-ops {
  display: flex;
  gap: 10px;

  ::v-deep .el-button {
    flex: 1;
  }
}
.search-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;

  ::v-deep .el-input {
    flex: 1;
  }
}
.filter-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;

  .tag-filter {
    width: 120px;
  }
}
.n-card {
  border-radius: 10px;
  border: none;
  margin-bottom: 10px;

  ::v-deep .el-card__body {
    padding: 12px 14px;
  }
}
.n-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.n-tag {
  padding: 2px 10px;
  font-size: 12px;
  color: #fff;
  background: #3b6ef0;
  border-radius: 10px;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.n-meta {
  font-size: 12px;
  color: #a8b0c0;

  .used {
    margin-left: 6px;
    font-style: normal;
    color: #f0a020;
  }
}
.n-content {
  font-size: 14px;
  line-height: 1.6;
  color: #2c3550;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 132px;
  overflow: hidden;
}
.n-foot {
  margin-top: 8px;
  text-align: right;

  ::v-deep .el-button {
    padding: 0;
    margin-left: 12px;
    font-size: 13px;
  }
  .use-btn {
    color: #3b6ef0;
    font-weight: 600;
  }
  .del-btn {
    color: #f56c6c;
  }
}
.empty {
  text-align: center;
  font-size: 13px;
  color: #a8b0c0;
  padding: 24px 0;
}
.more {
  text-align: center;
  padding: 6px 0 16px;
}
</style>
